import { normalizeKnownBuiltinAgentControllerId } from "./schemas/daemon/agent-controller-ref.js";
//#region src/agent-controller-brand.ts
const BUILTIN_AGENT_CONTROLLER_BRAND_IDS = [
	"codex",
	"claude-code",
	"opencode",
	"openclaw"
];
const BUILTIN_AGENT_CONTROLLER_BRANDS = {
	"claude-code": {
		accentHex: "#d97757",
		accentRgb: [
			217,
			119,
			87
		],
		controllerId: "claude-code",
		selectionMixPercent: 34
	},
	codex: {
		accentHex: "#869fff",
		accentRgb: [
			134,
			159,
			255
		],
		controllerId: "codex",
		selectionMixPercent: 36
	},
	opencode: {
		accentHex: "#000000",
		accentRgb: [
			0,
			0,
			0
		],
		controllerId: "opencode",
		selectionMixPercent: 24
	},
	openclaw: {
		accentHex: "#d43838",
		accentRgb: [
			212,
			56,
			56
		],
		controllerId: "openclaw",
		selectionMixPercent: 32
	}
};
function isBuiltinAgentControllerBrandId(value) {
	return value in BUILTIN_AGENT_CONTROLLER_BRANDS;
}
function resolveBuiltinAgentControllerBrand(agentControllerRef) {
	if (!agentControllerRef) return null;
	const controllerId = normalizeKnownBuiltinAgentControllerId(agentControllerRef);
	if (!(controllerId && isBuiltinAgentControllerBrandId(controllerId))) return null;
	return BUILTIN_AGENT_CONTROLLER_BRANDS[controllerId];
}
//#endregion
export { BUILTIN_AGENT_CONTROLLER_BRANDS, BUILTIN_AGENT_CONTROLLER_BRAND_IDS, isBuiltinAgentControllerBrandId, resolveBuiltinAgentControllerBrand };

//# sourceMappingURL=agent-controller-brand.js.map